/** @format */

import React from 'react';

import { Modal, Button, Spinner } from 'react-bootstrap';

export default function CommonModal({
  showModal,
  handleClose,
  header,
  body,
  button_1,
  button_2,
  handleBtn1,
  handleBtn2,
  loading,
  centerButtons
}) {
  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      backdrop='static'
      keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <p className='text1 pink-text'>{header}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='text2r'>{body}</p>
      </Modal.Body>
      <Modal.Footer>
        {loading ? (
          <div className='modal-center-loading'>
            <Spinner
              animation='border'
              role='status'
              style={{ color: 'var(--color-primary-pink)' }}
            />
          </div>
        ) : (
          <div className={`${centerButtons && 'modal-center-buttons'}`}>
            <Button
              className={`btn btn-pink ${
                centerButtons && 'modal-full-width-buttons modal-button-spacing'
              }`}
              onClick={handleBtn1}>
              {button_1}
            </Button>
            <Button
              className={`btn btn-white ${
                centerButtons && 'modal-full-width-buttons'
              }`}
              onClick={handleBtn2}>
              {button_2}
            </Button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
}
